import "./ButtonStateSwitch.less";

import * as React from "react";
import { CSSTransition } from "react-transition-group";

import { IBaseProps } from "lib/data/interfaces";


interface IButtonStateSwitchProps extends IBaseProps {
	on: string;
	in: any;
	children: React.ReactNode;
	className?: string;
	onShow?: () => void;
}

export const ButtonStateSwitch = (props: IButtonStateSwitchProps) => {

	if (props.onShow && props.on === props.in) {

		props.onShow();
	}

	return (
		<div className={`button-switch-container ${props.in === props.on ? "button-switch-container-active" : ""} ${props.className || ""}`}>

			<CSSTransition
				in={props.in === props.on}
				timeout={{
					enter: 300,
					exit: 200,
				}}
				classNames="push-expand-transition"
				unmountOnExit={true}
			>
				{props.children}
			</CSSTransition>
		</div>
	);

};
